// src/widgets/ThemeMenu.jsx
import { useEffect, useRef, useState } from "react";
import { Palette, CheckCircle2, ChevronDown } from "lucide-react";
import { useKuizyTheme, themePresets } from "@/styles/kuizyTheme";

const Dot = ({ className = "" }) => (
  <span className={`inline-block w-3 h-3 rounded-full ${className}`} />
);

export default function ThemeMenu() {
  const { theme, setTheme, t } = useKuizyTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = e => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onClick);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  const Opt = ({ keyId, label, dot }) => (
    <button
      onClick={() => { setTheme(keyId); setOpen(false); }}
      className={`w-full h-9 px-3 rounded-lg flex items-center justify-between ${t.soft} ${t.menuText} hover:opacity-90 transition`}
      aria-pressed={theme === keyId}
    >
      <span className="flex items-center gap-2">
        <Dot className={dot} />
        <span className="text-sm">{label}</span>
      </span>
      {theme === keyId ? <CheckCircle2 className="size-4 text-primary" /> : null}
    </button>
  );

  return (
    <div
      ref={ref}
      className="fixed z-50"
      style={{
        top: "max(1rem, env(safe-area-inset-top))",
        right: "max(1rem, env(safe-area-inset-right))"
      }}
    >
      <div className="relative">
        <button
          onClick={() => setOpen(o => !o)}
          className={`h-10 pl-3 pr-2 rounded-full flex items-center gap-2 shadow-lg backdrop-blur ${t.chip}`}
          aria-haspopup="menu"
          aria-expanded={open}
        >
          <Palette className="size-4" />
          <span className="text-xs">ธีม</span>
          <ChevronDown className={`size-4 transition ${open ? "rotate-180" : ""}`} />
        </button>

        {open ? (
          <div className={`absolute right-0 mt-2 w-56 rounded-2xl p-2 shadow-2xl ${t.cardsolid}`}>
            <div className="px-2 py-1 text-xs opacity-70 select-none text-primary font-semibold">เลือกธีม</div>
            <div className="mt-2 space-y-2">
              <Opt keyId="dark" label="ดำ" dot="bg-gray-900" />
              <Opt keyId="white" label="ขาว" dot="bg-gray-200" />
              <Opt keyId="primary" label="ชมพู" dot="bg-pink-500" />
              <Opt keyId="secondary" label="ฟ้า" dot="bg-blue-500" />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
